export default __webpack_public_path__ + "static/media/3.496e1c81.jpg";